import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { post } from '../apiService';

export interface AskPatRequest {
  question: string;
  docType: 'market' | 'practice';
  docId: string;
  conversation_id: string;
}

export interface AskPatResponse {
  // Response structure will be updated once tested
  answer?: string;
  conversation_id?: string;
  [key: string]: unknown;
}

export const askPat = async (
  request: AskPatRequest
): Promise<AskPatResponse> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }

  const url = `/resourceMatrix/ask/pat?customerId=${customer}`;

  try {
    console.log('[AskPAT] Making API call', {
      url,
      request,
      customerId: customer,
    });

    const responseData = await post<AskPatResponse>(
      url,
      request as unknown as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    console.log('[AskPAT] API response received', {
      data: responseData,
    });

    return responseData;
  } catch (error) {
    console.error('[AskPAT] API call failed:', error);

    // Extract error message from response if available
    const errorMessage =
      (error as { response?: { data?: { error?: string; message?: string } } })
        ?.response?.data?.error ||
      (error as { response?: { data?: { message?: string } } })?.response
        ?.data?.message ||
      (error instanceof Error ? error.message : 'Unknown error') ||
      'Failed to get response from PAT';

    throw new Error(errorMessage);
  }
};

